<template>
	<div style="display: flex;justify-content: space-between;" @click="bgClick()">
		<div style="flex: 3;">
			<div>宽度:<input type="text" v-model="col" /><button @click="calcCol">计算</button></div>
			<draggable v-model="points" :group="pointsGrpup" animation="300">
				<div v-for="item in points">
					{{item.name}}
					<transition-group>
						<div class="pointBox" :key="'info1-' + item.id" :class="item.class"></div>
					</transition-group>
				</div>
			</draggable>
			<div>
				<div>
					<textarea v-model="importData"></textarea>
				</div>
				<button @click="importDataClick">导入数据</button>
				<button @click="printData()">输出数据</button>
			</div>
		</div>

		<div style="margin-left: 50px;flex: 15;">
			<div style="text-align: center;margin-bottom: 10px;">
				地图区域
			</div>
			<draggable v-model="map" handle=".mover" group="site" animation="300" @add="dragAdd" style="border: 1px solid red;min-height: 500px;">
				<div class="pointContainer" v-for="(x,index) in map" :key="index">
					<span class="mover">+</span>
					<div v-for="(y,ind) in x" :key="ind">
						<div v-if="map[index][ind].value < 0" class="pointBox"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click.left="switchBox(index,ind)">{{index}},{{ind}}</div>
						<div v-else-if="map[index][ind].value  == 0" class="pointBox pointBoxBlue"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click="switchBox(index,ind)">{{index}},{{ind}}</div>
						<div v-else-if="map[index][ind].value  == 3" class="pointBox pointBoxGreen"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click="switchBox(index,ind)">{{index}},{{ind}}</div>
						<div v-else-if="map[index][ind].value  == 4" class="pointBox pointBoxStation"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click="switchBox(index,ind)">{{index}},{{ind}}</div>
						<div v-else-if="map[index][ind].value  == 5" class="pointBox chargeStation"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click="switchBox(index,ind)">{{index}},{{ind}}</div>
						<div v-else-if="map[index][ind].value  == 9" class="pointBox pointBoxRed"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click="switchBox(index,ind)">{{index}},{{ind}}</div>
						<div v-else-if="map[index][ind].value  == 10" class="pointBox pointBoxStart"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click="switchBox(index,ind)">{{index}},{{ind}}</div>
						<div v-else-if="map[index][ind].value  == 11" class="pointBox pointBoxEnd"
							@contextmenu.prevent="rightEvent(index,ind,$event)" @click="switchBox(index,ind)">{{index}},{{ind}}</div>
					</div>
					<button @click="deleteCol(index)">删除</button>
				</div>
			</draggable>
		</div>
		
		<div style="width: 150px;" v-if="showMap">
			{{printMap}}
		</div>
			
		<div v-if="rightBox" @click.stop="" :style="{left: rightBoxLeft,top: rightBoxTop}"
			style="position: absolute;height: 270px;width: 200px;background-color: antiquewhite;padding: 10px;">
			<div>
				[{{mapI}}][{{mapJ}}]value:
				<div style="display: flex;justify-content: space-between;">
					<div @click="map[mapI][mapJ].value = -1" class="pointBox"></div>
					<div @click="map[mapI][mapJ].value = 0" class="pointBox pointBoxBlue"></div>
					<div @click="map[mapI][mapJ].value = 3" class="pointBox pointBoxGreen"></div>
					<div @click="map[mapI][mapJ].value = 4" class="pointBox pointBoxStation"></div>
					<div @click="map[mapI][mapJ].value = 5" class="pointBox chargeStation"></div>
				</div>
			</div>
			<div>
				data: <input type="text" v-model="map[mapI][mapJ].data">
			</div>
			<div>
				top: <input type="text" v-model="map[mapI][mapJ].top">
			</div>
			<div>
				bottom: <input type="text" v-model="map[mapI][mapJ].bottom">
			</div>
			<div>
				left: <input type="text" v-model="map[mapI][mapJ].left">
			</div>
			<div>
				right: <input type="text" v-model="map[mapI][mapJ].right">
			</div>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'

	export default {
		name: 'drag',
		components: {
			draggable
		},
		watch: {
			
		},
		data() {
			return {
				drag: false,
				col: 10,
				pointsGrpup: {
					name: 'site',
					pull: 'clone',
					put: false
				},
				points: [{
						id: 0,
						name: '禁止区域',
						value: -1,
						class: '',
						list: []
					},
					{
						id: 1,
						name: '子轨道',
						value: 0,
						class: 'pointBoxBlue',
						list: []
					},
					{
						id: 2,
						name: '母轨道/堆垛机',
						value: 3,
						class: 'pointBoxGreen',
						list: []
					},
					{
						id: 3,
						name: '结果轨迹',
						value: 9,
						class: 'pointBoxRed',
						list: []
					},
					{
						id: 4,
						name: '站点',
						value: 4,
						class: 'pointBoxStation',
						list: []
					},
					{
						id: 5,
						name: '充电桩',
						value: 5,
						class: 'chargeStation',
						list: []
					},
					{
						id: 6,
						name: '车辆位置',
						value: 66,
						class: 'chargeStation',
						list: []
					}
				],
				map: [],
				printMap: [],
				mapI: 0,
				mapJ: 0,
				rightBox: false,
				rightBoxTop: "0px",
				rightBoxLeft: "0px",
				importData: null,
				showMap: false
			};
		},
		methods: {
			deleteCol(index) {
				let map = this.map
				let mapTmp = []
				
				map.forEach((item,idx) => {
					if(index != idx){
						mapTmp.push(item)
					}
				})
				
				this.map = mapTmp;
			},
			rightEvent(x, y, e) {
				this.rightBox = true
				this.mapI = x
				this.mapJ = y
				this.rightBoxTop = e.y + "px"
				this.rightBoxLeft = e.x + "px"
			},
			bgClick() {
				this.rightBox = false
			},
			switchBox(x, y) {
				let mapTmp = JSON.parse(JSON.stringify(this.map))
				switch (mapTmp[x][y].value) {
					case -1:
						mapTmp[x][y].value = 0
						break;
					case 0:
						mapTmp[x][y].value = 3
						break;
					case 3:
						mapTmp[x][y].value = 4
						break;
					case 4:
						mapTmp[x][y].value = 5
						break;
					case 5:
						mapTmp[x][y].value = -1
						break;
					default:
						mapTmp[x][y].value = -1
				}
				this.map = mapTmp
				this.$forceUpdate()
				this.rightBox = false
			},
			importDataClick() {
				let that = this
				let tmp = JSON.parse(this.importData);
				let data = []
				let col = 0
				let firstMap = []
				let points = this.points
				
				for(var i=1;i<tmp.length-1;i++){
					let item = tmp[i]
					let data2 = []
					col = item.length - 2
					item.forEach((val, idx) => {
						if(idx > 0 && idx < item.length-1){
							let json = {
								value: val.value,
								data: val.data,
								top: val.top == null ? 1000: val.top,
								bottom: val.bottom == null ? 1000:val.bottom,
								left: val.left == null ? 1000:val.left,
								right: val.right == null ? 1000:val.right
							}
							data2.push(json)
						}
					})
					data.push(data2)
				}
				
				this.col = col
				this.map = data
			},
			printData() {
				let mapTmp = JSON.parse(JSON.stringify(this.map))//深度copy
				let disable = {"value":-1,"data":"","top":1000,"bottom":1000,"left":1000,"right":1000}
				let disableList = []
				for(var i = 0;i<this.col+2;i++){
					disableList.push(disable)
				}
				
				mapTmp.forEach((item,idx) => {
					item.unshift(disable)
					item.push(disable)
				})
				
				mapTmp.unshift(disableList)
				mapTmp.push(disableList)
				this.printMap = mapTmp
				this.showMap = true
			},
			calcCol() {
				let map = this.map
				let tmp = []
				let col = this.col
				let disable = {"value":-1,"data":"","top":1000,"bottom":1000,"left":1000,"right":1000}
				if(map.length > 0){
					for(var i=0;i<map.length;i++){
						tmp[i] = []
						for(var j=0;j<col;j++){
							if(j<map[i].length){
								tmp[i].push(map[i][j])
							}else{
								tmp[i].push(disable)
							}
						}
					}
					this.map = tmp
				}
			},
			getPoint(index){
				for(var i=0;i<this.points.length;i++){
					if(this.points[i].id == index){
						return this.points[i]
					}
				}
				return null;
			},
			dragAdd(e){
				let mapIdx = e.newDraggableIndex;
				let pointIdx = e.oldDraggableIndex;
				let point = this.getPoint(pointIdx)
				let map = this.map
				let col = this.col
				let items = []
				
				map[mapIdx] = []
				let json = {
					value: point.value,
					data: "",
					top: 1000,
					bottom: 1000,
					left: 1000,
					right: 1000
				}
				for(var i=0;i<col;i++){
					map[mapIdx].push(json)
				}
				
				this.map = map;
				this.$forceUpdate()
			}
		}
	}
</script>

<style>
	.pointContainer {
		display: flex;
		justify-content: center;
		/* margin-top: 1px; */
		margin: 0;
		padding: 0;
	}

	.pointBox {
		margin: 0;
		background: #bababa;
		width: 40px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
	}
	
	.pointBox:hover {
		background: #000000 !important;
		color: #fff;
	}

	.pointBoxGreen {
		background: #00ff7f !important;
	}

	.pointBoxBlue {
		background: #55aaff !important;
	}

	.pointBoxRed {
		background: #ff0000 !important;
	}

	.pointBoxStart {
		background: #ffaa00 !important;
	}

	.pointBoxEnd {
		background: #ff55ff !important;
	}

	.pointBoxStation {
		background: #ffff00 !important;
	}

	.chargeStation {
		background: #ffaa7f !important;
	}
</style>
